export default __webpack_public_path__ + "static/media/partnershipIcon2.6529e966.webp";